import { Link } from "react-router-dom";
import DramaCard from "@/components/feature/DramaCard";
import type { Drama } from "@/mocks/dramas";

export default function SimilarDramas({ items }: { items: Drama[] }) {
  if (items.length === 0) return null;

  return (
    <section className="border-t border-background-200/60 bg-background-100/50 py-16 md:py-20" aria-labelledby="similar-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="text-xs font-label tracking-[0.3em] text-accent-400">同款类似推荐</span>
            <h2 id="similar-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              看完这部，这几部同样上头
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              按照题材、节奏与情绪基调匹配，风格接近但各有看点，可以直接接着看下去。
            </p>
          </div>
          <Link
            to="/ranking"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2.5 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400 cursor-pointer"
          >
            回到排行榜
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}